import generatePromotionCardBlock from './generatePromotionCardBlock';

const generateLinkCard = (linkId, typeArray, title, date, imageUrl, bookLink) => {
	const template = generatePromotionCardBlock(title, date, imageUrl, bookLink);

	typeArray.forEach((type) => {
		template.classList.add(`-${type}`);
	});
	template.setAttribute('href', `promotions/${linkId}`);

	return template;
};

export default generateLinkCard;



// WEBPACK FOOTER //
// ./src/js/promotion/generateLinkCard.js